import { Location } from "history";
import * as React from "react";
import {
  matchPath as defaultMatchPath,
  Redirect,
  useLocation
} from "react-router-dom";

import { addValueToLinkState } from "seneca-common/utils/routing";

import { Link } from "./utils";

type Props = {
  children: React.ReactElement;
  redirectLink: Link;
  path: string | Location;
  exact?: boolean;
  matchPath?: typeof defaultMatchPath;
  location?: Location<any>;
};

export default function InternalRedirectOnlyRoute({
  children,
  redirectLink,
  path: pathProp,
  exact,
  matchPath = defaultMatchPath,
  location: _location
}: Props) {
  const hookLocation = useLocation<any>();

  const location = _location || hookLocation;

  const path = typeof pathProp === "string" ? pathProp : pathProp.pathname;

  const match = matchPath(location.pathname, {
    path,
    exact
  });

  if (!match) {
    return null;
  }

  if (location.state && location.state.internalRedirect) {
    return children;
  }

  return <Redirect to={redirectLink} />;
}

export const makeInternalRedirectState = (link: Location) =>
  addValueToLinkState(link, {
    internalRedirect: true
  });
